import styled from "@emotion/styled";
import {
  createPolymorphicComponent,
  Text,
  type TextProps,
} from "@mantine/core";

export const CardContainer = styled.div<{ disabled?: boolean }>`
  border-radius: 4px;
  width: 400px;
  min-height: 180px;
  background-color: ${({ theme }) => theme.colors.cardBackground[0]};
  box-shadow: ${({ theme }) => `${theme.colors.cardBoxShadow[0]} 0px 3px 8px`};
  transition: box-shadow 0.2s;
  color: ${({ disabled }) => (disabled ? "#DEE2E6" : "#1864ab")};
  padding: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: start;
  border-right: 5px solid
    ${({ disabled, theme }) => (disabled ? "#DEE2E6" : theme.colors.main[9])};
  cursor: pointer;

  ${({ disabled, theme }) =>
    disabled
      ? ""
      : `
&:hover {
  box-shadow: ${
    theme.colorScheme === "dark"
      ? theme.colors.cardBoxShadow[0]
      : "rgba(0, 0, 0, 0.24)"
  }
  0px 5px 18px;
}
  `}
`;

export const CardSeparator = styled.div<{ disabled?: boolean }>`
  margin-top: 10px;
  width: 100%;
  min-height: 2px;
  background-color: ${({ disabled, theme }) =>
    disabled ? "#DEE2E6" : theme.colors.main[9]};
`;

export const NoEntries = styled.p`
  color: #b4b4b4;
  font-style: italic;
  margin: 12px 0;
`;

export const BottomText = styled.p`
  color: #868e96;
  font-style: italic;
  margin: 0px 0 0 0;
`;

const _CardName = styled(Text)`
  margin: 6px 0 0 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CardName = createPolymorphicComponent<"text", TextProps>(
  _CardName,
);

export const ButtonContainer = styled.div`
  position: relative;
  bottom: 0px;
  display: flex;
  width: 100%;
  justify-content: end;
`;
